module.exports = __webpack_public_path__ + "media/images/icons/filled/signal-dcaf3f6efdea11cd69fee9ebbc44e629.svg";